import React from 'react';
import StatCard from '../shared/StatCard';

export const DashboardStats = ({ stats }) => {
  if (!stats) return null;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <StatCard
        title="Total Services"
        value={stats.total_services || 0}
        subtitle="Monitored"
      />
      
      <StatCard
        title="Active Anomalies"
        value={stats.active_anomalies || 0}
        subtitle="Detected"
      />
      
      <StatCard
        title="Resolved Anomalies"
        value={stats.resolved_anomalies || 0}
        subtitle="This month"
      />
      
      <StatCard
        title="Detection Accuracy"
        value={`${(stats.detection_accuracy * 100 || 0).toFixed(1)}%`}
      />
    </div>
  );
};

export default DashboardStats;
